export function errorToString (error) {
  if (!error || !error.response || !error.response.data || !error.response.data.errors) return 'Error from server'

  return error.response.data.errors.map(e => (
    `${e.title}: '${Object.entries(e.detail).map(entry => entry.join(': ')).join(', ')}'`
  )
  )
}
